export class DialogWithImageModel {
  imageUrl: string
  width?: string
  height?: string

}
